import axios from "axios";
import store from "../store/index";
import router from "../router/index";

const baseURL = process.env.NODE_ENV === "development" ? "/api" : "/api";

const instance = axios.create({
    baseURL: baseURL,
    // timeout: 5000,
});

instance.interceptors.request.use(
    (config) => {
        const token = localStorage.getItem("token") || "";
        if (token) config.headers.common["token"] = token;
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

instance.interceptors.response.use(
    (response) => {
        const code = response.data.code;
        if (code == 10002) {
            store.dispatch("clearUserMenu");
            localStorage.clear();
            router.push({ name: "login" });
        }
        return response;
    },
    (error) => {
        return Promise.reject(error);
    }
);

export default instance;
